export const STATISTICS_PUBLIC = 'statisticsPublic';

export const STATISTICS_PUBLIC_ACTIONS_NAME = {
  getPagesTable: `${STATISTICS_PUBLIC}/getPagesTable`,
  getSectionsTable: `${STATISTICS_PUBLIC}/getSectionsTable`,
  getViewsCountByTimeTable: `${STATISTICS_PUBLIC}/getViewsCountByTimeTable`,
  getVisitsCountByTimeTable: `${STATISTICS_PUBLIC}/getVisitsCountByTimeTable`,
  getVisitsCountByTimeChartData: `${STATISTICS_PUBLIC}/getVisitsCountByTimeChartData`,
  getViewsCountByTimeChartData: `${STATISTICS_PUBLIC}/getViewsCountByTimeChartData`,
};

export const STATISTICS_PUBLIC_MUTATIONS_NAME = {
  setPagesTable: `${STATISTICS_PUBLIC}/setPagesTable`,
  setSectionsTable: `${STATISTICS_PUBLIC}/setSectionsTable`,
  setViewsCountByTimeTable: `${STATISTICS_PUBLIC}/setViewsCountByTimeTable`,
  setVisitsCountByTimeTable: `${STATISTICS_PUBLIC}/setVisitsCountByTimeTable`,
  setVisitsCountByTimeChartData: `${STATISTICS_PUBLIC}/setVisitsCountByTimeChartData`,
  setViewsCountByTimeChartData: `${STATISTICS_PUBLIC}/setViewsCountByTimeChartData`,
};

export const STATISTICS_PUBLIC_GETTERS_NAME = {
  getPagesTable: `${STATISTICS_PUBLIC}/getPagesTable`,
  getSectionsTable: `${STATISTICS_PUBLIC}/getSectionsTable`,
  getViewsCountByTimeTable: `${STATISTICS_PUBLIC}/getViewsCountByTimeTable`,
  getVisitsCountByTimeTable: `${STATISTICS_PUBLIC}/getVisitsCountByTimeTable`,
  getVisitsCountByTimeChartData: `${STATISTICS_PUBLIC}/getVisitsCountByTimeChartData`,
  getViewsCountByTimeChartData: `${STATISTICS_PUBLIC}/getViewsCountByTimeChartData`,
};
